// extracted by css-extract-rspack-plugin
export default {"ParentIssueTokenContainer":"parent-issue-token-module__ParentIssueTokenContainer__bbfvwyb","ParentIssueTokenMain":"parent-issue-token-module__ParentIssueTokenMain__baPlq11"};